import { render } from "./ContratWizard.vue?vue&type=template&id=7f5168aa&scoped=true"
import script from "./ContratWizard.vue?vue&type=script&lang=js"
export * from "./ContratWizard.vue?vue&type=script&lang=js"

import "./ContratWizard.vue?vue&type=style&index=0&id=7f5168aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5168aa"]])

export default __exports__